import { render, staticRenderFns } from "./AddButtons.vue?vue&type=template&id=32f9307e&scoped=true&"
import script from "./AddButtons.vue?vue&type=script&lang=js&"
export * from "./AddButtons.vue?vue&type=script&lang=js&"
import style0 from "./AddButtons.vue?vue&type=style&index=0&id=32f9307e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9307e",
  null
  
)

export default component.exports